import React, { useEffect, useMemo, useState } from "react";
import { MembershipFilterBar } from "../../components/dashboard/MembershipFilterBar";
import { MembershipReport } from "../../components/dashboard/MembershipReport";
import { getCustomers, getRangeCustomerSales } from "../../lib/mockMember";
import { useQuery } from "@tanstack/react-query";
import { ErrorDialog } from "../../components/ui/notification";

/** @param {{ report:string }} args */
const MembershipComponent = ({ report }) => {
  const [range, setRange] = useState("12m");
  const [type, setType] = useState("all");
  const [status, setStatus] = useState("all");
  //(useState < "all") | "Active" | ("Inactive" > "all");
  const [tick, setTick] = useState(0);

  const [dismissed, setDismissed] = useState(false);

  // look into using useQueries ..

  const {
    data: members = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["customers", tick],
    queryFn: getCustomers,
    staleTime: 1000 * 60 * 15,
  });

  /**
   * @type {{
   *   data: {custsales: any[], subcustsales: any[]} | undefined,
   *   isLoading: boolean,
   *   isError: boolean
   * }}
   */

  const {
    data: rangeSales,
    isLoading: isLoadingRange,
    isError: isErrorRange,
  } = useQuery({
    queryKey: ["range", range, tick],
    queryFn: () => getRangeCustomerSales(range),
    staleTime: 1000 * 60 * 15,
  });

  const filtered = useMemo(() => {
    // console.log(members);

    for (const element of members) {
      let saleDict = null;

      if (element.cardtype === "CUST") {
        saleDict = (rangeSales?.custsales ?? []).find(
          (g) => g.custcode === element.custno.toString(),
        );
      } else if (element.cardtype === "CUSTSUB") {
        saleDict = (rangeSales?.subcustsales ?? []).find(
          (g) => g.subcustcode === element.custno.toString(),
        );
      }

      if (saleDict) {
        element.totalSpend = saleDict["samount"];
      } else {
        element.totalSpend = 0;
      }
    }

    // console.log("---");
    // console.log(rangeSales);
    // console.log(members.reduce((s, m) => s + m.totalSpend, 0));
    // console.log("---");
    // const now = new Date();
    // const months = range === "all" ? null : Number(range.replace("m", ""));
    // const cutoff = months
    //   ? new Date(now.getFullYear(), now.getMonth() - months, now.getDate())
    //   : null;
    // we don't want joindate to affect membership filteration
    return members.filter((m) => {
      //if (cutoff && new Date(m.joinDate) < cutoff) return false;
      if (type !== "all" && m.member_main_category !== type) return false;
      if (status !== "all" && m.status !== status) return false;
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, status, members, rangeSales]);
  // // removed because we don't want range to change data of general membership,

  const types = Array.from(new Set(members.map((m) => m.member_main_category)));
  const statusList = Array.from(new Set(members.map((m) => m.status)));

  const queryErrors = useMemo(() => {
    const errors = [
      {
        key: "rangeSales",
        label: "Range sales",
        isError: isErrorRange,
        error: "Error Loading Sales",
      },
      {
        key: "custData",
        label: "Customer data",
        isError: isError,
        error: "Error Loading Members",
      },
    ];

    return errors
      .filter((e) => e.isError)
      .map((e) => ({
        key: e.key,
        message: `${e.error}`,
      }));
  }, [isErrorRange, isError]);

  const errorSignature = queryErrors.map((e) => e.key).join(",");
  useEffect(() => {
    setDismissed(false);
  }, [errorSignature]);

  return (
    <>
      {(isLoading || isLoadingRange) && (
        <div className="loading-div">
          <div className="spinner"></div>
        </div>
      )}

      <ErrorDialog
        errors={dismissed ? [] : queryErrors}
        onClose={() => setDismissed(true)}
      />

      <MembershipFilterBar
        range={range}
        setRange={setRange}
        type={type}
        setType={setType}
        status={status}
        setStatus={setStatus}
        types={types}
        statusList={statusList}
        onRefresh={() => setTick((t) => t + 1)}
        // onRefresh={() => {
        //   console.log("Refreshed");
        //   fetchCustomers();
        // }}
        report={report}
      />

      <section className="pbi-canvas">
        <MembershipReport report={report} members={filtered} range={range} />
      </section>
    </>
  );
};

export default MembershipComponent;
